import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { CanopyRoleData } from "../..";
import { useCanopyRolesTableAgGridOptions } from "./hooks";

export type CanopyRolesTableProps = {
  onGridReady: (event: AgGrid.GridReadyEvent<CanopyRoleData>) => void;
  rowData: CanopyRoleData[];
  onCellClicked: (event: AgGrid.CellClickedEvent<CanopyRoleData>) => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
};

const CanopyRolesTable = ({
  rowData,
  onCellClicked,
  onGridReady,
  onFilterChanged,
}: CanopyRolesTableProps) => {
  const { colDefs } = useCanopyRolesTableAgGridOptions();
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      pagination: true,
      paginationPageSizeSelector: true,
      paginationPageSize: 50,
      overlayNoRowsTemplate: "No roles found",
      suppressRowClickSelection: true,
    },
  });

  return (
    <Grid
      onGridReady={onGridReady}
      columnDefs={colDefs}
      rowData={rowData}
      onCellClicked={onCellClicked}
      gridOptions={gridOptions}
      onFilterChanged={onFilterChanged}
    />
  );
};

export default CanopyRolesTable;
